// ФИО необязательно (заполняется только в профиле), поэтому если его нет — показываем email
export default function userDisplayName(user?: { fio?: string | null; email?: string | null } | null): string {
  const fio = user?.fio?.trim();
  if (fio) return fio;
  return user?.email?.trim() ?? "";
}
